export const bulkUploadXlsxHeader = {
  NOMER_AWB: 'Nomer AWB',
  ISI_PAKET: 'Isi Paket',
  VARIASI: 'Variasi',
  JUMLAH_ITEM: 'Jumlah Item (QTY)',
}

export const bulkUploadXlsxHeaderPosition = {
  'Nomer AWB': 'A',
  'Isi Paket': 'B',
  Variasi: 'C',
  'Jumlah Item (QTY)': 'D',
  Packaging: 'E',
}

const defaultFiledClass = {
  thClass: '!capitalize !text-black !font-medium !bg-[#F4F4F4] !py-[16px] !text-base',
  tdClass: '!text-black !text-left',
}

/**
 * Column configuration for bulk upload data table
 */
export const tableBulkUploadContentFields = [
  {
    key: 'awb',
    label: 'No AWB',
    ...defaultFiledClass,
  },
  {
    key: 'name',
    label: 'Isi Paket',
    ...defaultFiledClass,
    tdClass: '!text-black min-w-[300px]',
  },
  {
    key: 'variant',
    label: 'Variasi',
    ...defaultFiledClass,
    tdClass: '!text-black min-w-[300px]',
  },
  {
    key: 'quantity',
    label: 'Jumlah Item',
    ...defaultFiledClass,
    tdClass: '!text-black min-w-[200px]',
  },
  {
    key: 'packaging',
    label: 'Bahan Packing',
    ...defaultFiledClass,
    tdClass: '!text-black min-w-[200px]',
  },
  {
    key: 'price',
    label: 'Biaya',
    formatter: value => `Rp ${(value || 0).toLocaleString('id-ID')}`,
    ...defaultFiledClass,
    tdClass: '!text-black min-w-[100px]',
  },
  {
    key: 'action',
    label: 'Action',
    ...defaultFiledClass,
  },
]

export const bulkUploadXlsxErrorFields = [
  {
    key: 'row',
    label: 'Paket',
    formatter: value => `Baris ke-${value}`,
    ...defaultFiledClass,
    tdClass: '!text-black !text-left min-w-[130px]',
  },
  {
    key: 'column',
    label: 'Kolom',
    ...defaultFiledClass,
  },
  {
    key: 'row',
    label: 'Perlu Perbaikan',
    ...defaultFiledClass,
  },
  {
    key: 'message',
    label: 'Alasan',
    ...defaultFiledClass,
  },
]

const pickupErrorMessage = {
  insufficient_balance: 'Saldo tidak mencukupi',
  failed_to_submit: 'Gagal mengajukan packing',
  failed_upload_resi: 'Gagal mengunggah resi',
  no_file_provided: 'Tidak ada file resi',
  component_not_found: 'Sistem error',
}

export const pickupErrorFields = [
  {
    key: 'order',
    label: 'Gudang',
    thClass: `${defaultFiledClass.thClass} text-left`,
    tdClass: defaultFiledClass.tdClass,
  },
  {
    key: 'reason',
    label: 'Detail Error',
    thClass: `${defaultFiledClass.thClass} text-left`,
    tdClass: '!text-black !text-left min-w-[300px]',
    formatter: value => pickupErrorMessage[value],
  },
]

export const chargeType = {
  1: 'Qty',
  2: 'm²',
}

const modalPackingSettingsClass = {
  ...defaultFiledClass,
  tdClass: '!text-black !text-left !px-[16px]',
}

export const fieldsModalPackingSettings = [
  {
    key: 'action',
    label: '',
    thStyle: 'width: 48px;',
    ...modalPackingSettingsClass,
  },
  {
    key: 'name',
    label: 'Jenis Packaging',
    ...modalPackingSettingsClass,
  },
  {
    key: 'layer',
    label: 'Lapis',
    thStyle: 'width: 150px;',
    ...modalPackingSettingsClass,
  },
]

export const statusMapping = {
  Unknown: {
    label: 'Unknown',
    color: {
      main: '#525252',
      sub: '#F5F5F5',
    },
  },
  'Belum Dipacking': {
    label: 'Belum Dipacking',
    color: {
      main: '#3B82F6',
      sub: '#EFF6FF',
    },
  },
  Dipacking: {
    label: 'Dipacking',
    color: {
      main: '#F95E16',
      sub: '#FFE8D9',
    },
  },
  'Menunggu Pickup': {
    label: 'Menunggu Pickup',
    color: {
      main: '#EAB308',
      sub: '#FEFCE8',
    },
  },
  Dikirim: {
    label: 'Terkirim',
    color: {
      main: '#10B981',
      sub: '#ECFDF5',
    },
  },
  Dibatalkan: {
    label: 'Dibatalkan',
    color: {
      main: '#DC2626',
      sub: '#FEF2F2',
    },
  },
}

export const defaultThClass = 'align-middle text-capitalize font-medium text-[#0A0A0A] text-[14px] px-[12px] py-[10px]'
const defaultTdClass = 'align-middle font-medium'

export const fieldsHistoryPacking = [
  {
    key: 'select',
    label: '',
    thClass: `${defaultThClass} w-[48px] text-center`,
    tdClass: `${defaultTdClass} text-center`,
  },
  {
    key: 'id',
    label: 'Outbond ID',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
    thStyle: {
      minWidth: '220px',
    },
  },
  {
    key: 'order_date',
    label: 'Tanggal Order',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
    thStyle: {
      minWidth: '200px',
    },
  },
  {
    key: 'warehouse_name',
    label: 'Mitra Gudang',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
    thStyle: {
      minWidth: '200px',
    },
  },
  {
    key: 'total_products',
    label: 'Jumlah Item',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
    thStyle: {
      minWidth: '130px',
    },
  },
  {
    key: 'total_orders',
    label: 'Jumlah Order',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
    thStyle: {
      minWidth: '140px',
    },
  },
  {
    key: 'status',
    label: 'Status',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
    thStyle: {
      minWidth: '150px',
    },
  },
  {
    key: 'aksi',
    label: 'Aksi',
    thClass: defaultThClass,
    tdClass: defaultTdClass,
    thStyle: {
      minWidth: '140px',
    },
  },
]
